import React from "react";
import Card from "react-bootstrap/Card";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
// import Tooltip from "react-bootstrap/Tooltip";
import Popover from "react-bootstrap/Popover";
import "./cards.scss";
import Buttons from "../Buttons";
import { Icons } from "../Icons";
import { Link } from "react-router-dom";
export const Cards = (props) => {
  const tooltip = (
    <Popover id="popover-contained" className="popover-inner">
      <Popover.Body style={{ paddingTop: "5px" }}>
        <div className="Why-cant-I-edit-cer mb-2">
          <strong>Why can&apos;t I edit certain fields?</strong>
        </div>
        <div className="Changing-your-title mb-2">
          Changing your title, name(s), date of birth or National Insurance
          number can only be done through your current employer.
        </div>
        <div className="Changing-your-title">
          Please contact them to process any changes.
        </div>
      </Popover.Body>
    </Popover>
  );

  return (
    <Card className="card-container">
      <Card.Body>
        <Card.Title>
          <div className="parent-div">
            <div className="left-div">
              {props.title}
              {props.persona === true ? (
                <OverlayTrigger
                  placement="right"
                  overlay={tooltip}
                  style={{ background: "red" }}
                  flip={true}
                >
                  <span className="icon-margin">
                    <Icons iconname="tool-tip" variant="icon-sixteen-px" />
                  </span>
                </OverlayTrigger>
              ) : props.bankDetailsTooltip && props.title === "Bank details" ? (
                <OverlayTrigger
                  placement="right"
                  overlay={props.bankDetailsTooltip}
                  style={{ backgroundColor: "red" }}
                  flip={true}
                >
                  <span className="icon-margin-bank-detail">
                    <Icons iconname="tool-tip" variant="icon-sixteen-px" />
                  </span>
                </OverlayTrigger>
              ) : (
                ""
              )}
            </div>

            {props.status === true ? (
              <div>
                <Buttons className="tertiary-pending" name="Pending Change" />
                <Icons
                  iconname="form-fields-pending-non-editing"
                  variant="icon-sixteen-px"
                />
              </div>
            ) : props.edit === true ? (
              ""
            ) : props.uploadButton === true ? (
              <div>
                <a onClick={props.uploadClick}>
                  <span className="icon">
                    <Icons iconname="external-link" variant="icon-sixteen-px" />
                  </span>
                  <Buttons className="tertiary" name="Upload document" />
                </a>
              </div>
            ) : (
              <div>
                <Link
                  style={
                    props.editDisable === true ? { cursor: "not-allowed" } : {}
                  }
                  to=""
                  onClick={props.editHandler}
                >
                  <span className="icon">
                    <Icons iconname="edit" variant="icon-twenty-four-px" />
                  </span>
                  <Buttons
                    style={
                      props.editDisable === true
                        ? { cursor: "not-allowed" }
                        : {}
                    }
                    className="tertiary"
                    name="Edit"
                  />
                </Link>
              </div>
            )}
          </div>
        </Card.Title>{" "}
        <div className="mb-3">{props.children}</div>
        {props.displayButton === true ? (
          <Card.Footer
            style={{
              background: "transparent",
              padding: "0px",
              borderTop: "none",
            }}
          >
            <div className="parent-div">
              <div style={{ paddingRight: "0px" }}>
                <Buttons
                  className="secondary"
                  name="Cancel changes"
                  handleClick={props.cancelHandler}
                />
              </div>
              <div>
                <Buttons
                  className="primary"
                  name="Confirm changes"
                  handleClick={props.confirmHandler}
                />
              </div>
            </div>
          </Card.Footer>
        ) : (
          ""
        )}
      </Card.Body>
    </Card>
  );
};
